import React, { useEffect, useState } from 'react';
import { VignetteProps } from '../types';

const QUERY = 'car insurance';

const TypewriterSearch: React.FC<VignetteProps> = ({ targetRect, reduced }) => {
  const [typed, setTyped] = useState(reduced ? QUERY : '');

  useEffect(() => {
    if (reduced) return undefined;
    let k = 0;
    let timer: number;
    const type = () => {
      k += 1;
      setTyped(QUERY.slice(0, k));
      if (k < QUERY.length) timer = window.setTimeout(type, 55 + Math.random() * 60);
    };
    timer = window.setTimeout(type, 600);
    return () => window.clearTimeout(timer);
  }, [reduced]);

  if (!targetRect) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: targetRect.top,
        left: targetRect.left,
        width: targetRect.width,
        height: targetRect.height,
        borderRadius: 100,
        background: '#F7F5F8',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '0 16px',
        pointerEvents: 'none',
        fontFamily: 'Grift, sans-serif',
      }}
      aria-hidden="true"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9A89AE" strokeWidth="2.4" strokeLinecap="round">
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-3.5-3.5" />
      </svg>
      <span style={{ color: '#39264F', fontSize: 14, fontWeight: 500 }}>
        {typed}
        {!reduced && (
          <span
            style={{
              display: 'inline-block',
              width: 1,
              height: 14,
              background: '#573A78',
              verticalAlign: -2,
              marginLeft: 1,
              animation: 'shepherdBlink 1s steps(1) infinite',
            }}
          />
        )}
      </span>
      <style>{'@keyframes shepherdBlink { 50% { opacity: 0; } }'}</style>
    </div>
  );
};

export default TypewriterSearch;
